import { ChangeDetectionStrategy, Component, Input, ViewChild } from "@angular/core";
import { FeatureName } from "@common/ADAPT.Common.Model/embed/feature-name.enum";
import { Person } from "@common/ADAPT.Common.Model/person/person";
import { PersonFlag } from "@common/ADAPT.Common.Model/person/person-flag.enum";
import { AdaptClientConfiguration } from "@common/configuration/adapt-client-configuration";
import { GuidedTourService } from "@common/lib/guided-tour/guided-tour.service";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { DismissibleCtaComponent } from "@org-common/lib/call-to-action/dismissible-cta/dismissible-cta.component";
import { FeaturesService } from "@org-common/lib/features/features.service";
import { PersonFlagService } from "@org-common/lib/person/person-flag.service";
import { EmbedShellTour, EmbedShellTourButton } from "app/tours/embed-shell-tour";

@Component({
    selector: "adapt-embed-shell-tour-prompt-dashboard-element",
    templateUrl: "./embed-shell-tour-prompt-dashboard-element.component.html",
    styles: [":host { display: contents }"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class EmbedShellTourPromptDashboardElementComponent extends BaseComponent {
    public readonly projectLabel = AdaptClientConfiguration.AdaptProjectLabel;
    public readonly PersonFlag = PersonFlag;

    @Input({ required: true }) public person!: Person;

    @ViewChild(DismissibleCtaComponent) public ctaComponent?: DismissibleCtaComponent;

    constructor(
        private guidedTourService: GuidedTourService,
        private personFlagService: PersonFlagService,
        private featuresService: FeaturesService,
    ) {
        super();
    }

    public runTour() {
        this.guidedTourService.run(EmbedShellTour);
        this.ctaComponent?.dismiss(true);
    }

    public onDismiss(triggeredByRun: boolean) {
        if (!triggeredByRun) {
            this.guidedTourService.run(EmbedShellTourButton);
        }

        if (this.featuresService.isFeatureActive(FeatureName.PlatformAI)) {
            // if AI feature is enabled, AI tour is already included in the shell tour, so we can mark AI tour as completed when dismissing shell tour prompt
            this.personFlagService.setFlagAndSave(PersonFlag.AiTourDismissed, true).subscribe();
        }
    }
}
